var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"dialog":_vm.s_dialogProfile,"id":"dialog-profile"}},[_c('div',{style:(_vm.contentSize)},[_c('div',{attrs:{"id":"profile-div"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }